<template>
  <div>
    <v-text-field
      v-mask="'###-###-####'"
      :masked="false"
      :value="value"
      type="tel"
      solo
      clearable
      required
      clear-icon="mdi-close-circle"
      @click:clear="$emit('input',null)"
      :hide-details="errors.length ? false : true"
      :error-messages="errors"
      prepend-inner-icon="mdi-cellphone"
      placeholder="0xx-xxx-xxxx"
      @input="onInput"
    ></v-text-field>
  </div>
</template>

<script>
  export default {
    props: ['value','errors'],
    data() {
      return {
      }
    },
    methods:{
      onInput(event) {
        if(event) {
          let phone_number = event.replace(/-/g, "");
          this.$emit("input", phone_number);
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
</style>